import { type ReactNode } from 'react';
import './InfoCard.css';

interface InfoCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  href?: string;
}

export function InfoCard({ icon, title, description, href }: InfoCardProps) {
  const CardContent = () => (
    <>
      <div className="info-card-icon">
        {icon}
      </div>
      <div className="info-card-text">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </>
  );

  if (href) {
    const isExternal = href.startsWith('http') || href.startsWith('https') || href.startsWith('mailto:') || href.startsWith('tel:');
    return (
      <a 
        href={href}
        className="info-card"
        target={isExternal && !href.startsWith('mailto:') && !href.startsWith('tel:') ? '_blank' : undefined}
        rel={isExternal && !href.startsWith('mailto:') && !href.startsWith('tel:') ? 'noopener noreferrer' : undefined}
      >
        <CardContent />
      </a>
    );
  }

  return (
    <div className="info-card">
      <CardContent />
    </div>
  );
}
